import { Form, message } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { usePageCache } from '../../tools/utilHooks'
import {
  ImportExcelErrorType,
  resetStateAction,
  setFormDataAction,
  setImportExcelErrorTypeAction,
  setIsImportLoadingAction,
  setShowResultAction,
} from './reducer'
import { useDispatch } from 'react-redux'
import { useEffect, useRef } from 'react'
import {
  CHECK_PRODUCT_FILE,
  DOWN_GOODS_IMPORT_TEMPLATE,
  IMPORT_PRODUCT_BY_PROJECT,
} from '../../api/MaterialApi'
import { UploadFileItem } from '../../components/BatchUpload'
import { convertProjectTypeDTOList } from '../../components/RelationProjectCheckGroup/hooks'
import { convertImgResultState } from '../../components/BatchUpload/hooks'
import { SingleUploadRef } from '../../components/SingleUpload/hooks'
import _ from 'lodash'
import { isResponseCodeSuccess } from '../../tools/util'
import { materialTypeEnum } from '@/global/enum/product'

export function useSetupHook() {
  const [form] = Form.useForm()

  const { closeCurrentTab } = usePageCache()
  const state = useTypedSelector((state) => state.newBacthAddReducer)
  const { importExcelErrorType } = state
  const dispatch = useDispatch()

  const singleUploadRef = useRef<SingleUploadRef>(null)
  const handleJumpBrand = () => {
    history.push('/srm/brandList')
  }

  const resetPageState = () => {
    form.resetFields()
    dispatch(resetStateAction())
  }
  const handleClosePage = () => {
    form.resetFields()
    closeCurrentTab()
    dispatch(resetStateAction())
  }

  const handleStartImport = async () => {
    const formValues = await form.validateFields()
    const uploadExcel: UploadFileItem = formValues.file
    if (!formValues.file) {
      message.warning('物料表格未添加')
      return
    }
    // 没有上传excel和物料类型不一致，需要重新上传excel
    if (importExcelErrorType?.includes('2')) {
      message.warning('请重新选择文件')
      return
    }
    const imgs = convertImgResultState(formValues.imgs ?? [])
    dispatch(setIsImportLoadingAction(true))
    const res = await IMPORT_PRODUCT_BY_PROJECT({
      file: uploadExcel.originFile,
      imgs,
      productType: formValues.productType,
    })
    if (isResponseCodeSuccess(res.code)) {
      // message.success
      JumpResult()
    }
    dispatch(setIsImportLoadingAction(false))
  }
  function JumpResult() {
    dispatch(setShowResultAction(true))
  }
  function handleReselectFile() {
    form.resetFields(['file'])
    dispatch(setImportExcelErrorTypeAction(undefined))
    setTimeout(() => {
      singleUploadRef.current?.reselect()
    }, 500)
  }
  async function validateImportExcel(file: any) {
    const formValues = form.getFieldsValue()
    const res = await CHECK_PRODUCT_FILE({
      file: file,
      projectTypeDTOList: convertProjectTypeDTOList(
        formValues.relationProject ?? [],
      ),
    })

    if (isResponseCodeSuccess(res.code)) {
      if (!res.data) {
        dispatch(setImportExcelErrorTypeAction(res.msg as ImportExcelErrorType))
      } else {
        dispatch(setImportExcelErrorTypeAction('success'))
      }
    }
  }
  async function handleUploadSucceed(file: UploadFileItem) {
    await validateImportExcel(file.originFile)
  }

  const handleExcelDel = () => {
    dispatch(setImportExcelErrorTypeAction(undefined))
  }

  async function handleDownloadTemplate() {
    const formValues = form.getFieldsValue()
    if (
      materialTypeEnum.isLabelsMatchValue(
        ['电商供应商物料'],
        formValues.productType,
      )
    ) {
      if ((formValues.relationProject?.length ?? 0) < 1) {
        message.warning('电商供应商物料需勾选关联项目后导出')
        return
      }
    }
    await DOWN_GOODS_IMPORT_TEMPLATE({
      projectTypeDTOList: convertProjectTypeDTOList(formValues.relationProject),
    })
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
    if (_.has(changedValues, 'relationProject')) {
      handleMaterialTypeChange()
    }
  }
  const handleMaterialTypeChange = async () => {
    const file: UploadFileItem = form.getFieldValue('file')
    if (file) {
      await validateImportExcel(file.originFile)
    }
  }
  // const validateImportExcelDebouce = _.throttle(handleMaterialTypeChange, 3000)
  useEffect(() => {
    // getProjectList()
    return () => {
      resetPageState()
    }
    // eslint-disable-next-line
  }, [])

  return {
    form,
    state,
    singleUploadRef,
    handleJumpBrand,
    handleClosePage,
    handleStartImport,
    handleUploadSucceed,
    handleReselectFile,
    handleExcelDel,
    handleDownloadTemplate,
    handleFormDataChange,
    handleMaterialTypeChange,
  }
}
import { Form, message } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { usePageCache } from '../../tools/utilHooks'
import {
  ImportExcelErrorType,
  resetStateAction,
  setFormDataAction,
  setImportExcelErrorTypeAction,
  setIsImportLoadingAction,
  setShowResultAction,
} from './reducer'
import { useDispatch } from 'react-redux'
import { useEffect, useRef } from 'react'
import {
  CHECK_PRODUCT_FILE,
  DOWN_GOODS_IMPORT_TEMPLATE,
  IMPORT_PRODUCT_BY_PROJECT,
} from '../../api/MaterialApi'
import { UploadFileItem } from '../../components/BatchUpload'
import { convertProjectTypeDTOList } from '../../components/RelationProjectCheckGroup/hooks'
import { convertImgResultState } from '../../components/BatchUpload/hooks'
import { SingleUploadRef } from '../../components/SingleUpload/hooks'
import _ from 'lodash'
import { isResponseCodeSuccess } from '../../tools/util'
import { materialTypeEnum } from '@/global/enum/product'

export function useSetupHook() {
  const [form] = Form.useForm()

  const { closeCurrentTab } = usePageCache()
  const state = useTypedSelector((state) => state.newBacthAddReducer)
  const { importExcelErrorType } = state
  const dispatch = useDispatch()

  const singleUploadRef = useRef<SingleUploadRef>(null)
  const handleJumpBrand = () => {
    history.push('/srm/brandList')
  }

  const resetPageState = () => {
    form.resetFields()
    dispatch(resetStateAction())
  }
  const handleClosePage = () => {
    form.resetFields()
    closeCurrentTab()
    dispatch(resetStateAction())
  }

  const handleStartImport = async () => {
    const formValues = await form.validateFields()
    const uploadExcel: UploadFileItem = formValues.file
    if (!formValues.file) {
      message.warning('物料表格未添加')
      return
    }
    // 没有上传excel和物料类型不一致，需要重新上传excel
    if (importExcelErrorType?.includes('2')) {
      message.warning('请重新选择文件')
      return
    }
    const imgs = convertImgResultState(formValues.imgs ?? [])
    dispatch(setIsImportLoadingAction(true))
    const res = await IMPORT_PRODUCT_BY_PROJECT({
      file: uploadExcel.originFile,
      imgs,
      productType: formValues.productType,
    })
    if (isResponseCodeSuccess(res.code)) {
      // message.success
      JumpResult()
    }
    dispatch(setIsImportLoadingAction(false))
  }
  function JumpResult() {
    dispatch(setShowResultAction(true))
  }
  function handleReselectFile() {
    form.resetFields(['file'])
    dispatch(setImportExcelErrorTypeAction(undefined))
    setTimeout(() => {
      singleUploadRef.current?.reselect()
    }, 500)
  }
  async function validateImportExcel(file: any) {
    const formValues = form.getFieldsValue()
    const res = await CHECK_PRODUCT_FILE({
      file: file,
      projectTypeDTOList: convertProjectTypeDTOList(
        formValues.relationProject ?? [],
      ),
    })

    if (isResponseCodeSuccess(res.code)) {
      if (!res.data) {
        dispatch(setImportExcelErrorTypeAction(res.msg as ImportExcelErrorType))
      } else {
        dispatch(setImportExcelErrorTypeAction('success'))
      }
    }
  }
  async function handleUploadSucceed(file: UploadFileItem) {
    await validateImportExcel(file.originFile)
  }

  const handleExcelDel = () => {
    dispatch(setImportExcelErrorTypeAction(undefined))
  }

  async function handleDownloadTemplate() {
    const formValues = form.getFieldsValue()
    if (
      materialTypeEnum.isLabelsMatchValue(
        ['电商供应商物料'],
        formValues.productType,
      )
    ) {
      if ((formValues.relationProject?.length ?? 0) < 1) {
        message.warning('电商供应商物料需勾选关联项目后导出')
        return
      }
    }
    await DOWN_GOODS_IMPORT_TEMPLATE({
      projectTypeDTOList: convertProjectTypeDTOList(formValues.relationProject),
    })
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
    if (_.has(changedValues, 'relationProject')) {
      handleMaterialTypeChange()
    }
  }
  const handleMaterialTypeChange = async () => {
    const file: UploadFileItem = form.getFieldValue('file')
    if (file) {
      await validateImportExcel(file.originFile)
    }
  }
  // const validateImportExcelDebouce = _.throttle(handleMaterialTypeChange, 3000)
  useEffect(() => {
    // getProjectList()
    return () => {
      resetPageState()
    }
    // eslint-disable-next-line
  }, [])

  return {
    form,
    state,
    singleUploadRef,
    handleJumpBrand,
    handleClosePage,
    handleStartImport,
    handleUploadSucceed,
    handleReselectFile,
    handleExcelDel,
    handleDownloadTemplate,
    handleFormDataChange,
    handleMaterialTypeChange,
  }
}
